// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + ".js?v=2025-01-23T14-00-26.556Z";
};